module.exports = __webpack_public_path__ + "img/selected.854784da.svg";